import { connect } from "react-redux";
import { formatPrice } from "../../../services/helpers/Helper";

const Bill = (props) => {
   const { carts } = props;
   const { cartItems } = carts;
   const totalBill = () => {
      return cartItems ? cartItems.reduce((n, { total_price }) => n + total_price, 0) : 0;
   }
   return (
      <div className="footer-cart">
         <div className="footer-order-confirm">
            <div>
               <div>Tạm tính</div>
               <div>{formatPrice(totalBill())} ₫</div>
            </div>
            <div>
               <div>Phí vận chuyển</div>
               <div>0 ₫</div>
            </div>
            <div className="total">
               <div>Tổng tiền</div>
               <div>{formatPrice(totalBill())} ₫</div>
            </div>
         </div>
      </div>
   )
}
const mapStateToProps = (state) => {
   const { carts } = state;
   return {
      carts
   };
};

export default connect(mapStateToProps, {
})(Bill)